import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/hitechvn/web-user/src/components/recruitments/detail/Index.jsx");
